import React, { Component } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import ConfettiExplosion from 'react-confetti-explosion';

class Alerts extends Component {
render() {
    //Error Dialog 
    if (this.props.ActiveDia === 0) {
        return (
        <Dialog
        open={this.props.DiaPass}
        onClose={this.props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
            {"Sys Error."}
            </DialogTitle>
            <DialogActions>
                <Button onClick={this.props.handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );}

    //Password Incorrect Dialog 
    else if (this.props.ActiveDia === 1){
        return (
            <Dialog
            open={this.props.DiaPass}
            onClose={this.props.handleClose}
            sx={{"& .MuiDialog-container": {"& .MuiPaper-root": {
                width: "100%",
                maxWidth: "30em"
            }}}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                {"User password is incorrect."}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={this.props.handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    }

    //Logout Success Dialog 
    else if (this.props.ActiveDia === 2){
        return (
            <Dialog
            open={this.props.DiaPass}
            onClose={this.props.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                {"User successfully logged out."}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={this.props.handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    }

    //CreateUser Error:shortuser Dialog 
    else if (this.props.ActiveDia === 3){
        return (
            <Dialog
            open={this.props.DiaPass}
            onClose={this.props.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                {"Create user error"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Username must be at least 3 Characters.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    }

    //CreateUser Error:shortpass Dialog 
    else if (this.props.ActiveDia === 4){
        return (
            <Dialog
            open={this.props.DiaPass}
            onClose={this.props.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                {"Create user error"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Password must be at least 5 Characters.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    }

    //CreateUser Error:AlreadyExists Dialog 
    else if (this.props.ActiveDia === 5){
        return (
            <Dialog
            open={this.props.DiaPass}
            onClose={this.props.handleClose}
            sx={{"& .MuiDialog-container": {"& .MuiPaper-root": {
                width: "100%",
                maxWidth: "20em"
            }}}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                {"Create user error"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Username Already Exists.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    }

     //CreateUser Success Dialog 
     else if (this.props.ActiveDia === 6){
        return (
            <Dialog
            open={this.props.DiaPass}
            onClose={this.props.handleClose}
            sx={{"& .MuiDialog-container": {"& .MuiPaper-root": {
                width: "100%",
                maxWidth: "20em"
            }}}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                {"Success!"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        User has been created.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    }

    //LoginUser Error:InvalidLength Dialog 
    else if (this.props.ActiveDia === 7){
        return (
            <Dialog
            open={this.props.DiaPass}
            onClose={this.props.handleClose}
            sx={{"& .MuiDialog-container": {"& .MuiPaper-root": {
                width: "100%",
                maxWidth: "20em"
            }}}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                {"Login user error"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Enter a valid username.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    }

    //LoginUser Error:NotFound Dialog 
    else if (this.props.ActiveDia === 8){
        return (
            <Dialog
            open={this.props.DiaPass}
            onClose={this.props.handleClose}
            sx={{"& .MuiDialog-container": {"& .MuiPaper-root": {
                    width: "100%",
                    maxWidth: "20em"
                }}}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                {"Login user error"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Username not found.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    }

    //Adventure Complete:Success Dialog 
    else if (this.props.ActiveDia === 9){
        return (
            <Dialog
            open={this.props.DiaPass}
            onClose={this.props.handleClose}
            sx={{"& .MuiDialog-container": {"& .MuiPaper-root": {
                    width: "100%",
                    maxWidth: "20em"
                }}}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
                <ConfettiExplosion />
                <DialogTitle id="alert-dialog-title">
                {"🎉 Congrats! 🎉"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Adventure Completed.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    }

    //Adventure Complete:Success Dialog 
    else if (this.props.ActiveDia === 10){
        return (
            <Dialog
            open={this.props.DiaPass}
            onClose={this.props.handleClose}
            sx={{"& .MuiDialog-container": {"& .MuiPaper-root": {
                    width: "100%",
                    maxWidth: "20em"
                }}}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Adventure has been marked incomplete.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    }

}}

/*
<Dialog
    open={this.props.DiaPass}
    onClose={this.props.handleClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description">
    <DialogTitle id="alert-dialog-title">
        {"Use  Google's location service?"}
    </DialogTitle>
    <DialogContent>
        <DialogContentText id="alert-dialog-description">
            Dialog context
        </DialogContentText>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.props.handleClose}>Disagree</Button>
        <Button onClick={this.props.handleClose} autoFocus>
            Agree
        </Button>
    </DialogActions>
</Dialog>
  */
export default Alerts;